var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"static-progress-bar",style:({ border: '1px solid' + _vm.color, width: _vm.width, padding: _vm.padding })},[_c('v-progress-linear',{attrs:{"buffer-value":_vm.progressPercentage,"height":_vm.height,"color":"transparent","background-color":_vm.color}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }